import React, {useEffect} from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {requestGeoLocatioPermissions} from '../../utils/localization/request-location-permisions';

import {useContextState as useUserContext} from '../../context/user';
import {StackParamList} from '../stacks';

import {
  SignInScreen,
  PasswordRecoverScreen,
  PasswordChangeScreen,
  SignUpScreen,
  ResetSuccessScreen,
  RequestSuccessScreen,
  TermsScreen,
} from '../../screens/externals';
import {useGeolocationAlert} from '../../components/alerts/geolocation-alert';

const Stack = createNativeStackNavigator<StackParamList>();

export const NavigatorAnonymous = () => {
  const {setLocalizationActive} = useUserContext();
  const {GeolocationAlert, requestPermission} = useGeolocationAlert();

  useEffect(() => {
    requestGeoLocatioPermissions(
      hasPermission => {
        if (hasPermission) {
          setLocalizationActive(true);
        }
      },
      {
        android: requestPermission,
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslin
  return (
    <>
      <GeolocationAlert />
      <Stack.Navigator
        initialRouteName={'SignIn'}
        screenOptions={{headerShown: false}}>
        <Stack.Group>
          <Stack.Screen name="SignIn" component={SignInScreen} />
          <Stack.Screen name="SignUp" component={SignUpScreen} />
          <Stack.Screen
            name="PasswordChange"
            component={PasswordChangeScreen}
          />
          <Stack.Screen
            name="PasswordRecover"
            component={PasswordRecoverScreen}
          />
          <Stack.Screen name="ResetSuccess" component={ResetSuccessScreen} />
          <Stack.Screen
            name="RequestSuccess"
            component={RequestSuccessScreen}
          />
          <Stack.Screen name="Terms" component={TermsScreen} />
        </Stack.Group>
      </Stack.Navigator>
    </>
  );
};
